const widths = {
  max: {
    contractDataRowColumn: '32rem',
    emptyListInfoBox: '36rem',
    noContractInfoBox: '36rem',
    virtualizedList: '24rem',
    virtualizedListItem: '19.5rem',
    virtualizedListHeader: '22.4rem',
    root: '192rem',
    tooltip: '29rem',
    benefitsVariantsDropdown: '20.8rem',
    annualLeaveModalColumn: '9.2rem',
    projectListItemMembers: '17.6rem',
    timeReportStatsCell: '55.2rem',
    listSearchPill: '85rem',
    projectPositionDropdown: '24rem',
  },
  min: {
    dropdown: '10rem',
    positionRateInput: '1rem',
    listSearchPill: '25rem',
    transfersSummaryModal: '45.6rem',
    benefitsHistoryModal: '30rem',
    workedTimeStatsCell: '28rem',
    positionHistory: '79.2rem',
    postitionMembers: '60rem',
  },
  default: {
    approveAndSendRaiseModal: '77.5rem',
    timeReportFillModal: '36rem',
    salesInvoicesSummaryModal: '77.5rem',
    salesInvoiceSummaryTableCurrenciesColumn: '11.6rem',
    leaveAttachmentPreviewModal: '101rem',
    projectUtilizationFilterYearMonth: '26rem',
    projectUtilizationFilterThreshold: '18rem',
    datePickerCell: '3.6rem',
    datePickerHighlight: '.4rem',
    datePickerYear: '6.3rem',
    datePicker: '28.4rem',
    invoiceNumberInput: '20rem',
    signDraftInput: '16rem',
    navbar: '26.4rem',
    confirmationModal: '45.6rem',
    profileCompletionModal: '60rem',
    timeReportModal: '45.6rem',
    login: '52rem',
    spinner: '2rem',
    saveAsReadyModal: '36rem',
    contractActionsModals: '36rem',
    invoicePaidDateModal: '36rem',
    importBankTransfersModal: '36rem',
    importBankTransfersSummaryModal: '111.8rem',
    payrollTransfersOrderResultModal: '101.8rem',
    salariesLabel: '10.7rem',
    inlineSaveButton: '3.4rem',
    rightSidebar: '38.4rem',
    reportBlock: '36rem',
    bookingCard: '36rem',
    filePreviewModal: '79.2rem',
    drawer: '36rem',
    drawerWithSteps: '45rem',
    currencyIcon: '2rem',
    transferSummaryModal: '101.8rem',
    positionHistoryModal: '105.9rem',
    positionHistoryModalPositionButton: '21.3rem',
    transferSummaryTable: '70.9rem',
    transferSummaryTableCurrenciesColumn: '11.6rem',

    workingDayCheckbox: '3.6rem',
    workingDayHoursInput: '7.4rem',
    labeledFieldGridLabel: '10.5rem',
    companyFilterDropdown: '30rem',
    benefitVariantFilterDropdown: '50rem',
    inlineListSearchInput: '28rem',
    benefitIndexPane: '40rem',
    emptyStateIcon: '4rem',
    monthGridPersonColumn: '23.6rem',
    monthGridDayColumn: '4rem',
  },
};

export type DefaultWidth = keyof typeof widths.default;

export default widths;
